import { FC } from "react";
import { Grid } from "antd";
import { withConditionalComponent } from "src/HOC";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import PassengerSelectFieldWeb from "./layouts/PassengerSelectField.web";
import PassengerSelectFieldMob from "./layouts/PassengerSelectField.mob";

const PassengerSelectFieldComponent = withConditionalComponent(PassengerSelectFieldWeb, PassengerSelectFieldMob);

export type PassengerSelectOption = { value: string; label: string };

export type PassengerSelectFieldProps = {
  value?: string;
  onChange?: (value: string) => void;
  label?: string;
  placeholder?: string;
  options?: PassengerSelectOption[];
  showSearch?: boolean;
};

const PassengerSelectField: FC<PassengerSelectFieldProps> = (props) => {
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return <PassengerSelectFieldComponent trigger={isLargeScreen} props={props} />;
};

export default PassengerSelectField;
